import ThemedApp from "./ThemedApp";

export default function App() {
  return <ThemedApp />;
}
